var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono / Empresa / Plata@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Empresa-/-Plata",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 24 24 24 24 0 0 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#444444"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "9 8 11 8 11 4.037 9 4.037"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "13 8 15 8 15 4.037 13 4.037"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "9 13.963 11 13.963 11 10 9 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "13 13.963 15 13.963 15 10 13 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "9 19.926 11 19.926 11 15.963 9 15.963"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "13 19.926 15 19.926 15 15.963 13 15.963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0004,-0.0003 L5.0004,22.0007 L2.9994,22.0007 L2.9994,5.9997 L3.9994,5.9997 L3.9994,4.0007 L0.9994,4.0007 L0.9994,22.0007 L0.0004,22.0007 L0.0004,23.9997 L24.0004,23.9997 L24.0004,22.0007 L23.0004,22.0007 L23.0004,4.0007 L19.9994,4.0007 L19.9994,5.9997 L20.9994,5.9997 L20.9994,22.0007 L18.9994,22.0007 L18.9994,-0.0003 L5.0004,-0.0003 Z M7.0004,22.0007 L17.0004,22.0007 L17.0004,2.0007 L7.0004,2.0007 L7.0004,22.0007 Z",
    id: "Fill-8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.d57b41692f8b62a6f09621022cbbe479.svg";
export { ForwardRef as ReactComponent };